import FormatOption from './FormatOption';

export default class IncludeAlpha extends FormatOption {

    static default = false;

    static label = 'Include Alpha';

    output() {
        return this.decorator.output().replace('(', 'a(').replace(')', ', 1)');
    }

}